import { Component } from 'react'
import './styles.sass'
import { ItemSlider } from './slider'
import { RouterProps, withRouter } from '../../../../insfrastructure/utils/with-router-component'
import Oportunities from './components/oportunities'

class Home extends Component<RouterProps> {
  state = {
    slides: [
      '/assets/images/banner.png'
    ]
  }

  componentDidMount() {
    this.jumpToSection((this.props.params as any)['section'])
  }

  componentDidUpdate(prevProps: Readonly<RouterProps>, prevState: Readonly<{}>, snapshot?: any): void {
    if((prevProps.params as any)['section'] !== (this.props.params as any)['section']) {
      this.jumpToSection((this.props.params as any)['section']);
    };
  }

  jumpToSection = (section?: string) => {
    if(!section) {
      window.scrollTo({ top: 0, behavior: 'smooth' });

      return;
    };

    const sectionElement = document.querySelector('.'+section) as HTMLElement;

    window.scrollTo({ top: sectionElement.offsetTop - 50, behavior: 'smooth' });
  }

  render() {
    return (
      <div className='home'>
        <div className='slider-container'>
          <ItemSlider passedSlides={this.state.slides} />
        </div>
        <Oportunities />
      <div className='how-to-anounce'>
        <div className='content'>
          <div className='block'>
            <div className='title'>
              <h1>Como Anunciar</h1>
            </div>
            <div className='columns'>
              <div className='left'>
                <div className='steps'>
                  <h4>Instruções para Empresas Já Cadastradas:</h4>
                  <div>
                    <p><b>1</b> - Acesse o Site</p>
                    <p>Todas as vagas devem ser cadastradas exclusivamente pelo site.</p>
                    {/* <p>Acesse: www.empregamecanico.com.br</p> */}
                  </div>
                  <div>
                    <p><b>2</b> - Faça o Login na Sua Conta</p>
                    <p>Clique em <b>"Entre"</b> no canto superior direito e entre com o e-mail e senha cadastrados.</p>
                  </div>
                  <div>
                    <p><b>3</b> - Vá até o Menu de Vagas</p>
                    <p>No seu painel de controle, clique em <b>"Criar nova vaga"</b>.</p>
                  </div>
                  <div>
                    <p><b>4</b> - Preencha os Dados da Vaga</p>
                    <p>Complete o formulário com todas as informações necessárias: Dados básicos, Salário e benefícios, e Requisitos.</p>
                  </div>
                  <div>
                    <p><b>5</b> - Publique a Vaga</p>
                    <p>Revise todas as informações no resumo da vaga e clique em <b>"Criar vaga"</b> para concluir a publicação.</p>
                  </div>
                </div>
                <div className='image-block'>
                  <img src='/assets/images/home/photo1.png' alt='signed_in_companies' />
                </div>
              </div>
              <div className='right'>
                <div className='image-block'>
                  <img src='/assets/images/home/photo2.png' alt='not_signed_in_companies' />
                </div>
                <div className='steps'>
                  <h4>Instruções para Empresas no Primeiro Acesso:</h4>
                  <div>
                    <p><b>1</b> - Acesse o Site</p>
                    <p>Todas as vagas devem ser cadastradas exclusivamente pelo site.</p>
                    {/* <p>Acesse: www.empregamecanico.com.br</p> */}
                  </div>
                  <div>
                    <p><b>2</b> - Inicie o Cadastro da Empresa</p>
                    <p>Na página inicial, clique em <b>“Cadastro”</b>, no canto superior direito, e depois selecione a opção <b>“Empresas”</b>.</p>
                  </div>
                  <div>
                    <p><b>3</b> - Preencha os Dados</p>
                    <p>Informe todos os dados solicitados, incluindo as informações da empresa e o perfil do responsável pelo cadastro.</p>
                  </div>
                  <div>
                    <p><b>4</b> - Revise e Envie</p>
                    <p>Verifique se todas as informações estão corretas e finalize o cadastro.</p>
                  </div>
                  <p>Aguarde a Confirmação</p>
                  <div>
                    <p><b>5</b> - Aguarde a Confirmação</p>
                    <p>Você receberá um e-mail confirmando o cadastro da sua empresa e as instruções para começar a publicar vagas.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='about-us'>
        <div className='content'>
          <div className='block'>
            <div className='title'>
              <h1>Sobre o Emprega Mecânico</h1>
            </div>
            <div className='about-text'>
              <p>Somos a primeira e única plataforma focada em conectar profissionais do setor automotivo às melhores oportunidades de trabalho no Brasil. Ajudamos a fortalecer o setor ao facilitar a colocação de talentos qualificados, desde alunos da Escola do Mecânico até profissionais experientes de todo o país. Nosso propósito é conectar o talento certo à vaga certa, impulsionando carreiras e movimentando o setor automotivo brasileiro.</p>
            </div>
            <div className='columns'>
              <div className='left'>
                <div className='text'>
                  <h3>O Que Fazemos</h3>
                  <div>
                    <h4>Para Empregadores:</h4>
                    <p>Conectamos sua empresa aos melhores talentos do setor automotivo.</p>
                    <ul>
                      <li><b>Acesso a Profissionais Qualificados:</b> Receba candidaturas de profissionais do setor automotivo alinhados e interessados no perfil da sua vaga.</li>
                      <li><b>Publicação de Vagas Simples e Eficiente:</b> Anuncie suas oportunidades com praticidade em uma plataforma feita exclusivamente para o setor de reparação automotiva.</li>
                    </ul>
                  </div>
                  <div>
                    <h4>Para Candidatos:</h4>
                    <p>Ajudamos você a dar o próximo passo na sua carreira.</p>
                    <ul>
                      <li><b>Encontre Oportunidades que Combinam com Você:</b> Navegue e aplique-se para oportunidades no setor automotivo via nosso aplicativo ou plataforma web.</li>
                      <li><b>Acompanhe Seu Processo Seletivo:</b> Saiba exatamente em que etapa está sua candidatura, com transparência e agilidade. Tudo em um só lugar.</li>
                    </ul>
                  </div>
                  <div>
                    <h3>Benefícios</h3>
                    <ul>
                      <li><b>Para Alunos e Ex-Alunos da Escola do Mecânico:</b> Conquiste sua primeira vaga ou avance na sua carreira com oportunidades reais no setor.</li>
                      <li><b>Para Profissionais de Todo o Brasil:</b> Tenha acesso a vagas em diversas regiões do país, com foco no setor de reparação automotiva.</li>
                      <li><b>Para Empresas:</b> Receba candidaturas de talentos qualificados, técnicos e interessados em ingressar no setor automotivo.</li>
                      <li><b>Para o Emprega Mecânico:</b> Nosso propósito é conectar profissionais e empresas, promovendo impacto social e desenvolvimento do setor.</li>
                      <li><b>Para a Sociedade:</b> Contribuímos para um mercado automotivo mais qualificado e geramos impacto social ao aproximar oportunidades de quem mais precisa.</li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className='right'>
                <div className='text'>
                  <h3>Como Funciona</h3>
                  <div>
                    <h4>Para o Empregador:</h4>
                    <ol>
                      <li>Cadastre sua vaga de forma simples e atrativa. Receba candidaturas de profissionais qualificados e gerencie tudo pelo painel da sua empresa.</li>
                      <li>O acesso aos currículos é liberado apenas para quem se candidatar à sua vaga.</li>
                    </ol>
                  </div>
                  <div>
                    <h4>Para o Candidato:</h4>
                    <ol>
                      <li>Acesse o aplicativo ou a plataforma web para encontrar as melhores oportunidades no setor automotivo.</li>
                      <li>Candidate-se com facilidade, aguarde o contato do empregador e acompanhe o status das suas inscrições diretamente no seu perfil.</li>
                    </ol>
                  </div>
                </div>
                <div className='image-block'>
                  <img src='/assets/images/home/photo3.png' alt='how_it_works_image' />
                </div>
              </div>
            </div>
            <div className='bottom-text'>
              <p>Emprega Mecânico – Conectando talentos e oportunidades para um futuro profissional bem-sucedido. Para mais informações, entre em contato conosco através do email contato@empregamecanico.com.br.</p>
            </div>
          </div>
        </div>
      </div>
      <div className='success-stories'>
        <div className='content'>
          <div className='block'>
            <div className='title'>
              <h1>Histórias de Sucesso</h1>
            </div>
            <div>
              <h2>Transformando Vidas com Emprega Mecânico</h2>
              <p>No Emprega Mecânico, não apenas conectamos profissionais e empresas – transformamos vidas e carreiras. Nossa missão vai além de preencher vagas; buscamos criar oportunidades reais que impactam positivamente a trajetória de nossos candidatos e o sucesso das empresas que atendemos. Aqui, compartilhamos algumas das histórias inspiradoras de como nossa plataforma fez a diferença.</p>
            </div>
          </div>
        </div>
      </div>
      {/* <iframe
      title='chatbot'
      src="https://dify.nytro-labs.com.br/chatbot/uMdf9e2FTE4fDORq"
      style={{width: '100%', height: '100%', minHeight: '700px'}}
      frameBorder="0"
      allow="microphone">
      </iframe> */}
      <div className='contact'>
        <div className='content'>
          <div className='block'>
            <div className='title'>
              <h1>Fale conosco</h1>
            </div>
            <div className='block-content'>
              <div className='text'>
                <p>Estamos aqui para ajudar! Se você tiver dúvidas, precisar de suporte ou desejar mais informações sobre o Emprega Mecânico, não hesite em nos contatar. Nossa equipe está à disposição para garantir que sua experiência com nossa plataforma seja a melhor possível.</p>
              </div>
              <div className='columns'>
                <div className='left'>
                  <div className='form-container'>
                    <form>
                      <Input
                      name='name'
                      label='Nome'
                      placeholder='Insira seu nome'/>
                      <Input
                      name='email'
                      label='Email'
                      placeholder='Insira seu email'/>
                      <Input
                      name='subject'
                      label='Assunto'
                      placeholder='Insira o assunto do email'/>
                      <Input
                      name='message'
                      label='Mensagem'
                      type='textarea'
                      placeholder='Insira sua mensagem'/>
                    </form>
                    <button className='secondary'>Enviar</button>
                  </div>
                </div>
                <div className='right'>
                  <div className='image-block'>
                    <img src='/assets/images/home/photo4.png' alt='contact-image' />
                  </div>
                </div>
              </div>
              <p className='contact-email'>contato@empregamecanico.com.br</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    )
  }
}

const Input = ({ name, label, placeholder, type }: { name: string, label: string, placeholder: string, type?: string }) => {
  return (
    <div className='input-container'>
      <label>{label}</label>
      {
        type !== 'textarea' ?
        <input name={name} type={type ? type : 'text'} placeholder={placeholder} /> :
        <textarea name={name} placeholder={placeholder}></textarea>
      }
    </div>
  )
}

export default withRouter(Home);